import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { IconButton } from "../../../../common/components/button/iconButton/IconButton";
import { IconType } from "../../../../common/icons/Icon";
import { UnitOfMeasure } from "../../../../common/enums";
import { IInventoryTransferLineFormModel } from "../models/inventoryTransferModels";
import styles from "./InventoryTransferLinesTable.module.scss";
import { Calendar } from "primereact/calendar";

interface ILinesTableProps {
  lines: IInventoryTransferLineFormModel[];
  disabled: boolean;
  onQuantityChange: (index: number, qty: number) => void;
  onExpirationChange: (index: number, date: Date | null) => void;
  onRemove: (index: number) => void;
}

const uomLabel = (uom: UnitOfMeasure) =>
  uom === UnitOfMeasure.Gram ? "гр." : "бр.";

export const InventoryTransferLinesTable = ({
  lines,
  disabled,
  onQuantityChange,
  onExpirationChange,
  onRemove,
}: ILinesTableProps) => {
  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <span className={styles.col_product}>Продукт</span>
        <span className={styles.col_qty}>Количество</span>
        <span className={styles.col_uom}>Мярка</span>
        <span className={styles.col_expiry}>Срок на годност</span>
        <span className={styles.col_remove} />
      </div>

      <RenderWhen condition={lines.length === 0}>
        <div className={styles.empty}>Няма добавени продукти.</div>
      </RenderWhen>

      {lines.map((line, index) => (
        <div key={index} className={styles.row}>
          <span className={styles.col_product}>
            <span className={styles.emoji}>{line.emoji ?? "📦"}</span>
            <span className={styles.name}>{line.productName}</span>
          </span>

          <span className={styles.col_qty}>
            <input
              type="number"
              min={0}
              step={1}
              value={line.quantity ?? ""}
              disabled={disabled}
              onChange={(e) => {
                const raw = e.target.value;
                onQuantityChange(index, raw === "" ? (null as any) : Number(raw));
              }}
              onKeyDown={(e) => {
                if (e.key === "." || e.key === ",") {
                  e.preventDefault();
                }
              }}
              onBlur={(e) => {
                if (e.target.value === "") {
                  onQuantityChange(index, 0);
                }
              }}
              onWheel={(e) => (e.target as HTMLInputElement).blur()}
              className={styles.qtyInput}
            />
            <span className={styles.uomMobile}>{uomLabel(line.unitOfMeasure)}</span>
          </span>

          <span className={styles.col_uom}>{uomLabel(line.unitOfMeasure)}</span>

          <span className={styles.col_expiry}>
            <span className={styles.expiryLabel}>Срок на годност</span>
            <Calendar
              value={line.expirationDate}
              onChange={(e) => onExpirationChange(index, (e.value as Date | null) ?? null)}
              dateFormat="dd/mm/yy"
              showIcon
              disabled={disabled}
              placeholder="Незадължително"
              className={styles.calendar}
            />
          </span>

          <span className={styles.col_remove}>
            <RenderWhen condition={!disabled}>
              <IconButton
                iconType={IconType.DeleteIcon}
                iconWidth="24px"
                iconHeight="24px"
                tooltip="Премахни реда"
                onClick={() => onRemove(index)}
              />
            </RenderWhen>
          </span>
        </div>
      ))}
    </div>
  );
};
